/**
 * Engaging Networks Dev Bypass Utility
 *
 * Provides utilities to bypass EN submissions in development mode
 * while still running validation and logging what would be sent.
 */

export type ENSubmissionType = 'signup' | 'comment' | 'consultation' | 'completion';

/**
 * Checks if EN submissions should be bypassed
 * Returns true if:
 * - Running in dev mode (import.meta.env.DEV is true), OR
 * - VITE_BYPASS_EN_SUBMISSIONS env variable is set to 'true'
 */
export function shouldBypassENSubmission(): boolean {
  // Check explicit bypass flag first
  if (import.meta.env.VITE_BYPASS_EN_SUBMISSIONS === 'true') {
    return true;
  }
  
  // Check if running in dev mode
  return import.meta.env.DEV === true;
}

/**
 * Logs EN submission data in a consistent format
 * @param endpoint The endpoint URL that would be called
 * @param data The data that would be sent
 * @param type The type of submission (signup, comment, consultation, completion)
 */
export function logENSubmissionData(
  endpoint: string,
  data: Record<string, unknown> | URLSearchParams,
  type: ENSubmissionType
): void {
  console.group(`[EN BYPASS] ⚠️  Engaging Networks submission bypassed (dev mode)`);
  console.log(`[EN BYPASS] Endpoint: ${endpoint}`);
  console.log(`[EN BYPASS] Submission Type: ${type}`);
  console.log(`[EN BYPASS] Data that would be sent:`);
  
  // Convert URLSearchParams to object if needed
  let dataObj: Record<string, unknown>;
  if (data instanceof URLSearchParams) {
    dataObj = Object.fromEntries(data);
  } else {
    dataObj = data;
  }
  
  // Log formatted data
  console.log(dataObj);
  console.log(`[EN BYPASS] ✅ Validation passed - would submit successfully`);
  console.groupEnd();
}

